<div [formGroup]="uploadToDocBoxForm">
    <div class="row">
        <label
            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_UPLOAD_TO_DOCBOX_LABEL"
        ></label>
        <div class="col-12 col-lg-auto mb-3">
            <pace-core-radio-input
                [(model)]="model.uploadToDocBoxOptions"
                [parentForm]="uploadToDocBoxFormChildren"
                id="radioDocBoxOptions"
                (valueChange)="onOptionChange()"
            ></pace-core-radio-input>
        </div>
        <div class="col-auto">
            <button
                class="btn btn-primary"
                translate="CONFIRMATION_UPLOAD_TO_DOCBOX_ADD_LABEL"
                (click)="uploadFile()"
                *ngIf="model.documentTitle.length > 0"
            ></button>
        </div>
    </div>
    <div class="row mb-3" *ngIf="model.documentTitle.length > 0">
        <label class="col-2 col-form-label"></label>
        <div class="col-8">
            <strong>{{ 'CONFIRMATION_UPLOADED_TO_DOCBOX_LABEL' | translate }}</strong>
            <div *ngFor="let docTitle of model.documentTitle">{{ docTitle }}</div>
        </div>
    </div>
</div>
